import {inject, Injectable} from '@angular/core';
import {ServiceCase} from '../../service-case/models/service-case';
import {UserService} from '../../user/services/user.service';
import {VehicleWarningLoader} from '../../vehicle-warning/services/vehicle-warning.loader';
import {VehicleCampaignCollection} from '../interfaces/vehicle-campaign-collection';
import {CampaignService} from './campaign.service';
import {UserData} from "../../user/models/user-data";

@Injectable({
  providedIn: 'root'
})
export class CampaignLoader {
  private readonly campaignService: CampaignService = inject(CampaignService);
  private readonly userService: UserService = inject(UserService);
  private readonly vehicleWarningLoader: VehicleWarningLoader = inject(VehicleWarningLoader);

  loadCampaignsInServiceCase(serviceCase: ServiceCase): Promise<boolean> {
    if (!serviceCase.getVinLong()) {
      return Promise.resolve(this.updateCampaignsInServiceCase(serviceCase, null));
    }

    const user: UserData = this.userService.getCurrentUser();
    return new Promise(resolve => {
      this.campaignService.getCampaigns(
        serviceCase.getVinLong(),
        user.getContext(),
        user.getLocale(),
        user.getB2XCountryCode(),
        user.getBusinessPartner()
      )
        .then(campaigns => resolve(this.updateCampaignsInServiceCase(serviceCase, campaigns)))
        .catch(reason => {
          this.logBackendErrors(reason);
          resolve(this.updateCampaignsInServiceCase(serviceCase, undefined));
        });
    });
  }

  private updateCampaignsInServiceCase(serviceCase: ServiceCase,
                                       vehicleCampaignCollection: VehicleCampaignCollection): boolean {
    serviceCase.setCampaigns(vehicleCampaignCollection);
    return this.vehicleWarningLoader.addTechnicalCampaignWarningsToServiceCase(serviceCase);
  }

  private logBackendErrors(error: string): void {
    console.log(error);
  }
}
